module.exports = __webpack_public_path__ + "media/images/icons/monitor-c5a89d5d6c431690042a2f1db09c7402.svg";